import { render, staticRenderFns } from "./DatabaseModals.vue?vue&type=template&id=42b77bd8&scoped=true&lang=pug&"
import script from "./DatabaseModals.vue?vue&type=script&lang=ts&"
export * from "./DatabaseModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b77bd8",
  null
  
)

export default component.exports